export default {
  disasterAvoidPolygons: {
    name: 'Name',
    description: 'Beschreibung',
    disasterType: 'Katastrophen-Typ',
    disasterSubType: 'Katastrophen-Subtyp',
    fillRequiredFields: 'Bitte füllen Sie die erforderlichen Felder für den Katastrophenbereich aus',
    avoidAreaSaved: 'Katastrophenbereich gespeichert',
    avoidAreaDeleted: 'Katastrophenbereich gelöscht',
    fillAreaProperties: 'Füllen Sie die Eigenschaften des Katastrophenbereiches aus und speichern Sie sie',
    editProperties: 'Eigenschaften bearbeiten',
    createADisasterPolygon: 'Katastrophen-Polygon erstellen',
    createADisasterRectangle: 'Katastrophen-Rechteck erstellen',
    errorWhileTryingToSaveDisasterArea: 'Fehler beim Versuch, den Katastrophenbereich zu speichern',
    authorizationError: 'Autorisierungsfehler. Bitte stellen Sie sicher, dass der eingegebene Schlüssel gültig ist. Um den Schlüssel erneut einzugeben, laden Sie die Seite neu',
    DisasterAreaUsageInfo: 'Sie können: die Kartenansicht verschieben, um Katastrophenbereiche einer Zielregion zu laden, mit den Polygon-Zeichenwerkzeugen neue Katastrophenbereiche erstellen und auf einen Katastrophenbereich klicken, um ihn zu bearbeiten',
    errorCodes: {
      2404: 'Anbieter existiert nicht',
      3404: 'Katastrophen-Typ existiert nicht',
      5409: 'Name des Katastrophenbereich wird bereits verwendet'
    },
    statuses: {
      401: 'Nicht autorisiert',
    }
  }
}